module.exports = __webpack_public_path__ + "static/img/8.0d80c61f.jpg";